module.exports = __webpack_public_path__ + "static/media/logo.759a2075.svg";